angular.module('filters')
    .filter('convertOSVersion', () => (versionNr, osType) => {

        let version = versionNr;
        /* for desktop versions take only the number from the versionNr */
        if (osType === 'desktop') {

            version = parseFloat(versionNr);
            if (version === 10) {

                if (versionNr.split('.')[2] && parseFloat(versionNr.split('.')[2].slice(0, 2)) > 21) {

                    version = 11;

                }

            }

            if (Number.isNaN(version)) {

                return '';

            }

        }

        switch (version) {

        case 6.1:
            return (!osType || osType === 'desktop') ? '7' : 'Server 2008 R2';
        case 6.0:
            return (!osType || osType === 'desktop') ? 'Vista' : 'Server 2008';
        case 6.3:
            return (!osType || osType === 'desktop') ? '8.1' : 'Server 2012';
        case 6.2:
            return (!osType || osType === 'desktop') ? '8' : '';
        case 5.2:
            return (!osType || osType === 'desktop') ? 'XP 64-Bit' : 'Server 2003';
        case 5.1:
            return (!osType || osType === 'desktop') ? 'XP' : '';
        case 5.0:
            return (!osType || osType === 'desktop') ? '2000' : '';
        case 8.1:
            return (!osType || osType === 'desktop') ? '8.1' : 'Server 2012';
        case 10.0:
            return (!osType || osType === 'desktop') ? '10' : '';
        case 11.0:
            return (!osType || osType === 'desktop') ? '11' : '';
        case 'iPhone1,1':
            return 'iPhone';
        case 'iPhone1,2':
            return 'iPhone 3G';
        case 'iPhone2,1':
            return 'iPhone 3GS';
        case 'iPhone3,1':
        case 'iPhone3,2':
        case 'iPhone3,3':
            return 'iPhone 4';
        case 'iPhone4,1':
            return 'iPhone 4S';
        case 'iPhone5,1':
        case 'iPhone5,2':
            return 'iPhone 5';
        case 'iPhone5,3':
        case 'iPhone5,4':
            return 'iPhone 5C';
        case 'iPhone6,1':
        case 'iPhone6,2':
            return 'iPhone 5S';
        case 'iPhone7,2':
            return 'iPhone 6';
        case 'iPhone7,1':
            return 'iPhone 6 Plus';
        case 'iPhone8,1':
            return 'iPhone 6S';
        case 'iPhone8,2':
            return 'iPhone 6S Plus';
        case 'iPad1,1':
            return 'iPad';
        case 'iPad2,1':
        case 'iPad2,2':
        case 'iPad2,3':
            return 'iPad 2';
        case 'iPad3,1':
        case 'iPad3,2':
        case 'iPad3,3':
            return 'iPad 3';
        case 'iPad3,4':
        case 'iPad3,5':
        case 'iPad3,6':
            return 'iPad 4';
        case 'iPad4,1':
        case 'iPad4,2':
        case 'iPad4,3':
            return 'iPad Air';
        case 'iPad5,3':
        case 'iPad5,4':
            return 'iPad Air 2';
        case 'iPad6,7':
        case 'iPad6,8':
            return 'iPad Pro';
        case 'iPad2,5':
        case 'iPad2,6':
        case 'iPad2,7':
            return 'iPad mini';
        case 'iPad4,4':
        case 'iPad4,5':
        case 'iPad4,6':
            return 'iPad mini 2';
        case 'iPad4,7':
        case 'iPad4,8':
        case 'iPad4,9':
            return 'iPad mini 3';
        case 'iPad5,1':
        case 'iPad5,2':
            return 'iPad mini 4';


        default:
            return '';

        }

    });



// WEBPACK FOOTER //
// ./scripts/common/filters/os.js